document.querySelectorAll('[id^="Details-HeaderMenu"]').forEach((details) => {
  const summary = details.querySelector('summary');
  const megaMenuContent = details.querySelector('.mega-menu__content'); // Ensure correct class

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', details.hasAttribute('open'));

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  // Open mega menu when hovering over summary
  summary.addEventListener('mouseenter', () => {
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  // Keep menu open while hovering over mega menu content
  if (megaMenuContent) {
    megaMenuContent.addEventListener('mouseenter', () => {
      details.setAttribute('open', '');
    });

    // Close menu only when leaving both summary and mega menu content
    megaMenuContent.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });
  }

  // If summary itself loses hover AND user isn’t inside mega menu, close menu
  summary.addEventListener('mouseleave', () => {
    setTimeout(() => {
      if (!details.matches(':hover')) {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }
    }, 200); // Small delay to allow transition between elements
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


